import { render, staticRenderFns } from "./roleAdmin.vue?vue&type=template&id=b9a7173a&"
import script from "./roleAdmin.vue?vue&type=script&lang=js&"
export * from "./roleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./roleAdmin.vue?vue&type=style&index=0&id=b9a7173a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports